import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@naf-simba/building-blocks-typography';

export const InfoText = () => (
  <Typography variant="textMItalic">
    Finn fristen i søkemotoren ovenfor, og bestill gratis varsling for når kontrollfristen din er. Har du allerede
    logget inn på Mitt NAF, huker du av for varslingstjenesten, der du finner bilen din under &quot;
    <Link to="/mitt-naf/mine-kjoretoy">Mine kjøretøy</Link>&quot;.
  </Typography>
);
